var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_21114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9989 8.36914H9.51792C8.59977 8.36914 7.85547 9.11345 7.85547 10.0316V17.5126C7.85547 18.4308 8.59977 19.1751 9.51792 19.1751H16.9989C17.9171 19.1751 18.6614 18.4308 18.6614 17.5126V10.0316C18.6614 9.11345 17.9171 8.36914 16.9989 8.36914Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.66245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53274 13.3567H3.70151C3.2606 13.3567 2.83775 13.1816 2.52598 12.8698C2.21421 12.558 2.03906 12.1352 2.03906 11.6943V4.21323C2.03906 3.77232 2.21421 3.34947 2.52598 3.0377C2.83775 2.72593 3.2606 2.55078 3.70151 2.55078H11.1825C11.6235 2.55078 12.0463 2.72593 12.3581 3.0377C12.6698 3.34947 12.845 3.77232 12.845 4.21323V5.04446",
    stroke: "#9CA3AF",
    strokeWidth: 1.66245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_21114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9494,
    height: 19.9494,
    fill: "white",
    transform: "translate(0.375 0.888672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy1);
export default __webpack_public_path__ + "static/media/copy1.1ab89128ddebbabf0abd3ac051d3c743.svg";
export { ForwardRef as ReactComponent };